<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="封面" prop="image" >
        <file-upload v-model="form.image" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="用戶ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="請輸入用戶ID" />
      </a-form-model-item>
      <a-form-model-item label="觀看總人數" prop="totalNumber" >
        <a-input v-model="form.totalNumber" placeholder="請輸入觀看總人數" />
      </a-form-model-item>
      <a-form-model-item label="直播狀態 " prop="directStatus" >
      </a-form-model-item>
      <a-form-model-item label="是否前置攝像頭" prop="isFront" >
        <a-input v-model="form.isFront" placeholder="請輸入是否前置攝像頭" />
      </a-form-model-item>
      <a-form-model-item label="是否打開麥克風" prop="microphone" >
        <a-input v-model="form.microphone" placeholder="請輸入是否打開麥克風" />
      </a-form-model-item>
      <a-form-model-item label="是否打開攝像頭" prop="camera" >
        <a-input v-model="form.camera" placeholder="請輸入是否打開攝像頭" />
      </a-form-model-item>
      <a-form-model-item label="創建人" prop="createBy" >
        <a-input v-model="form.createBy" placeholder="請輸入創建人" />
      </a-form-model-item>
      <a-form-model-item label="編輯人" prop="updateBy" >
        <a-input v-model="form.updateBy" placeholder="請輸入編輯人" />
      </a-form-model-item>
      <a-form-model-item label="刪除狀態(0-正常,1-已刪除)" prop="delFlag" >
        <a-input v-model="form.delFlag" placeholder="請輸入刪除狀態(0-正常,1-已刪除)" />
      </a-form-model-item>
      <a-form-model-item label="直播時長" prop="closeTime" >
        <a-input v-model="form.closeTime" placeholder="請輸入直播時長" />
      </a-form-model-item>
      <a-form-model-item label="是否打開美顏 0-否 1-是" prop="isBeauty" >
        <a-input v-model="form.isBeauty" placeholder="請輸入是否打開美顏 0-否 1-是" />
      </a-form-model-item>
      <a-form-model-item label="PK狀態 0-未開始 1-準備中 2-pk中 3-pk成功 4-pk失敗 5-pk平局" prop="pkStatus" >
      </a-form-model-item>
      <a-form-model-item label="新增粉絲數量" prop="newFans" >
        <a-input v-model="form.newFans" placeholder="請輸入新增粉絲數量" />
      </a-form-model-item>
      <a-form-model-item label="獲贊數量" prop="likedNum" >
        <a-input v-model="form.likedNum" placeholder="請輸入獲贊數量" />
      </a-form-model-item>
      <a-form-model-item label="禮物數量" prop="giftNum" >
        <a-input v-model="form.giftNum" placeholder="請輸入禮物數量" />
      </a-form-model-item>
      <a-form-model-item label="顯示ID" prop="showId" >
        <a-input v-model="form.showId" placeholder="請輸入顯示ID" />
      </a-form-model-item>
      <a-form-model-item label="PK進行中,另外一個直播間的id" prop="directId" >
        <a-input v-model="form.directId" placeholder="請輸入PK進行中,另外一個直播間的id" />
      </a-form-model-item>
      <a-form-model-item label="PK進行中的id" prop="directPkId" >
        <a-input v-model="form.directPkId" placeholder="請輸入PK進行中的id" />
      </a-form-model-item>
      <a-form-model-item label="錄製視頻封面" prop="recordVideoCover" >
        <a-input v-model="form.recordVideoCover" placeholder="請輸入內容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="錄製視頻路徑" prop="recordVideo" >
        <a-input v-model="form.recordVideo" placeholder="請輸入內容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="錄製視頻時長" prop="recordVideoTime" >
        <a-input v-model="form.recordVideoTime" placeholder="請輸入錄製視頻時長" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDirectSeeding, addDirectSeeding, updateDirectSeeding } from '@/api/platform/directSeeding'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表單參數
      form: {
        id: null,

        image: null,

        userId: null,

        totalNumber: null,

        directStatus: 0,

        isFront: null,

        microphone: null,

        camera: null,

        createTime: null,

        createBy: null,

        updateBy: null,

        delFlag: null,

        closeTime: null,

        isBeauty: null,

        pkStatus: 0,

        newFans: null,

        likedNum: null,

        giftNum: null,

        showId: null,

        directId: null,

        directPkId: null,

        recordVideoCover: null,

        recordVideo: null,

        recordVideoTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按鈕
    cancel () {
      this.open = false
      this.reset()
    },
    // 表單重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        image: null,
        userId: null,
        totalNumber: null,
        directStatus: 0,
        isFront: null,
        microphone: null,
        camera: null,
        createTime: null,
        createBy: null,
        updateBy: null,
        delFlag: null,
        closeTime: null,
        isBeauty: null,
        pkStatus: 0,
        newFans: null,
        likedNum: null,
        giftNum: null,
        showId: null,
        directId: null,
        directPkId: null,
        recordVideoCover: null,
        recordVideo: null,
        recordVideoTime: null
      }
    /*  this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按鈕操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按鈕操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDirectSeeding({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按鈕 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDirectSeeding(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDirectSeeding(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
